<template>
  <div class="login-container">
    <el-form ref="loginForm"
             :model="loginForm"
             :rules="loginRules"
             class="login-form"
             auto-complete="on"
             label-position="left">
      <div class="title-container">
        <h3 class="title">
          <img src="../../assets/images/login-tu.png">
<!--          {{ $t('route.dashboard') }}-->
        </h3>
        <!-- <lang-select class="set-language" /> -->
      </div>
      <!-- 手机号验证码登录 -->
      <div class="yzmLogin">
        <el-form-item prop="username">
          <span class="svg-container">
            <svg-icon style="color: #e70012"
                      icon-class="user" />
          </span>
          <el-input ref="username"
                    v-model="loginForm.username"
                    placeholder="请输入您的账号"
                    name="username"
                    type="text"
                    auto-complete="on"
                    clearable />
        </el-form-item>

        <el-form-item prop="password">
          <span class="svg-container">
            <svg-icon style="color: #e70012"
                      icon-class="password" />
          </span>
          <el-input :key="passwordType"
                    ref="password"
                    v-model="loginForm.password"
                    :type="passwordType"
                    placeholder="请输入您的密码"
                    name="password"
                    auto-complete="on"
                    clearable
                    @keyup.enter.native="handleLogin" />
          <span class="show-pwd"
                @click="showPwd">
            <svg-icon :icon-class="
                              passwordType === 'password' ? 'eye' : 'eye-open'
                          " />
          </span>
        </el-form-item>
      </div>

      <div style="height:10px;" />
      <!-- 登录按钮 -->
      <el-button :loading="loading"
                 type="primary"
                 style="width: 100%; background: #e70012;border-radius: 4px;height: 48px;border-color: #e70012;"
                 @click.native.prevent="handleLogin">
        {{ $t('login.logIn') }}
      </el-button>
    </el-form>
  </div>
</template>

  <script>
import NProgress from 'nprogress' // progress bar
import PictureIdentify from '@/components/Identify/index.vue'
// eslint-disable-next-line no-unused-vars
import { validUsername } from '@/utils/validate'
import LangSelect from '@/components/LangSelect'
import SocialSign from './socialsignin'
import md5 from 'js-md5'
// import user from "@/api/user";

export default {
  name: 'Login',
  // eslint-disable-next-line vue/no-unused-components
  components: { LangSelect, SocialSign, PictureIdentify },
  data () {
    const validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('login.pleaseEnterUsername')))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error(this.$t('login.pleaseEnterPassword')))
      } else {
        callback()
      }
    }
    // 验证输入的图片验证码是否和存储的验证码相同
    const validatePhone = (rules, value, callback) => {
      if (value === '') {
        callback(new Error("手机号不能为空"))
      } else {
        callback()
      }
    }
    const validateuserma = (rules, value, callback) => {
      if (value === '') {
        callback(new Error("验证码不能为空"))
      } else {
        callback()
      }
    }
    return {
      totalTime: 60,
      macontent: "获取验证码",
      loginType: 2,//1账号密码登录；2手机号验证码登录
      showVertiryCode: false,
      pictureCode: '',
      loginForm: {
        username: '',
        password: '',
        userphone: '',
        userma: ''
      },
      loginRules: {
        username: [
          {
            required: true,
            trigger: 'blur',
            validator: validateUsername
          }
        ],
        password: [
          {
            required: true,
            trigger: 'blur',
            validator: validatePassword
          }
        ],
        userphone: [
          {
            required: true,
            trigger: 'blur',
            validator: validatePhone
          }
        ],
        userma: [
          {
            required: true,
            trigger: 'blur',
            validator: validateuserma
          }
        ]
      },
      passwordType: 'password',
      loading: false,
      showDialog: false,
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created () {
  },
  mounted () {
    // if (this.loginForm.username === '') {
    //   this.$refs.username.focus()
    // } else if (this.loginForm.password === '') {
    //   this.$refs.password.focus()
    // }
  },
  destroyed () {
  },
  methods: {
    /*
* 验证是不是手机号。1开头的11位数字。
*/
    checkPhone: function (a) {
      var patrn = /^((?:11|12|13|14|15|16|17|18|19)\d{9}|0(?:10|2\d|[3-9]\d{2})[1-9]\d{6,7})$/
      if (!patrn.exec(a)) return false
      return true
    },
    // 验证码倒数计时
    yanzhegn () {
      this.interval = window.setInterval(() => {
        this.totalTime--;
        this.macontent = this.totalTime + 's后重新发送';
        //小于等于0的时候停止倒计时
        if (this.totalTime <= 0) {
          //停止倒计时方法
          window.clearInterval(this.interval);
          this.macontent = '获取验证码';
          this.totalTime = 60;
          return false;
        }
      }, 1000)
    },
    showPwd () {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin () {
      //停止倒计时方法
      window.clearInterval(this.interval);
      this.macontent = '获取验证码';
      this.totalTime = 60;
      let that = this;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          console.log(this.loginForm)
          this.loading = true;
          let params = {
            username: this.loginForm.username,
            password: this.loginForm.password,
            phone: this.loginForm.userphone,
            phonecode: this.loginForm.userma
          }
          this.$store
            .dispatch('user/login', params)
            .then((res) => {
              this.$router.push({ path: this.redirect || '/' })
              this.loading = false
              NProgress.done()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((err) => {
              this.showVertiryCode = true
              this.loading = false
              NProgress.done()
            })
        } else {
          // console.log("error submit!!");
          return false
        }
      })
    },
    // handleLogin () {
    //   //停止倒计时方法
    //   window.clearInterval(this.interval);
    //   this.macontent = '获取验证码';
    //   this.totalTime = 60;
    //   this.$refs.loginForm.validate((valid) => {
    //     if (valid) {
    //       this.loading = true
    //       this.$store
    //         .dispatch('user/phonelogin', { username: md5(this.loginForm.username), password: md5(this.loginForm.password), phone: this.loginForm.userphone, phonecode: this.loginForm.userma })
    //         .then((res) => {
    //           this.$router.push({ path: this.redirect || '/' })
    //           this.loading = false
    //           NProgress.done()
    //         })
    //         // eslint-disable-next-line handle-callback-err
    //         .catch((err) => {
    //           this.showVertiryCode = true
    //           this.loading = false
    //           NProgress.done()
    //         })
    //     } else {
    //       // console.log("error submit!!");
    //       return false
    //     }
    //   })
    // }
  }
}
  </script>

  <style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #666;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

input.el-input__inner::-webkit-input-placeholder {
  color: rgba(102, 102, 102, 1);
}

input.el-input__inner::-moz-placeholder {
  /* Mozilla Firefox 19+ */

  color: rgba(102, 102, 102, 1);
}

input.el-input__inner:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */

  color: rgba(102, 102, 102, 1);
}

input.el-input__inner:-ms-input-placeholder {
  /* Internet Explorer 10-11 */

  color: rgba(102, 102, 102, 1);
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: #333;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        -webkit-animation: autofill-fix 1s infinite !important;
        /* 选择历史记录的文字颜色*/
        -webkit-text-fill-color: #333;
        -webkit-transition: background-color 50000s ease-in-out 0s !important;
        transition: background-color 50000s ease-in-out 0s !important;
        background-color: transparent !important;
        background-image: none !important;
        /* 选择历史记录的背景颜色 */
        -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
      }
    }
  }

  .el-form-item {
    // border: 1px solid rgba(255, 255, 255, 0.1);
    // background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }

  .el-form-item__content {
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid #ffffff;
    border-radius: 4px;
  }
}
</style>

  <style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: rgba(64, 127, 255, 0.1);
  background: url(../../assets/images/login-bg.jpg) no-repeat center;
  background-size: cover;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    overflow: hidden;
    padding: 0 32px 40px;

    // height: 350px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid #ffffff;
    box-shadow: 0px 0px 21px 0px rgba(66, 129, 228, 0.15);
    border-radius: 8px;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #000000;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 32px 0;

      img {
        display: block;

        margin-right: 12px;
      }
    }

    .set-language {
      color: #fff;
      position: absolute;
      top: 3px;
      font-size: 18px;
      right: 0px;
      cursor: pointer;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}

.row-vertiry {
  display: flex;
  margin-bottom: 18px;
}

.row-vertiry .s-canvas {
  margin-left: 40px;
}

.row-vertiry .el-form-item {
  flex: 1;
  margin-bottom: 0;
}

.userma-btn {
  line-height: 47px;
  background: rgb(253, 150, 43);
  color: #fff;
  padding: 0 15px;
  text-align: center;
  display: inline-block;
  border-radius: 5px;
}

.login-container .yzmLogin /deep/.el-input {
  display: inline-block;
  height: 47px;
  flex: 1;
}

.login-container .yzmLogin /deep/.el-form-item__content {
  display: flex;
  align-items: center;
}
</style>
